import React, { useMemo } from 'react';

import { AppstoreOutlined, CloudServerOutlined } from '@ant-design/icons';

import { FloatButtonGroup } from '@/shared/ui/FloatButtonGroup';
import type { FloatButtonItem } from '@/shared/ui/FloatButtonGroup';

import type { PlatformLineageView } from '@/features/lineage/api';

type ViewSelectorProps = {
  selectedView: PlatformLineageView;
  onViewChange: (view: PlatformLineageView) => void;
};

const viewConfig: Array<{
  type: PlatformLineageView;
  icon: React.ReactNode;
  label: string;
}> = [
  { type: 'service', icon: <CloudServerOutlined />, label: '서비스' },
  { type: 'domain', icon: <AppstoreOutlined />, label: '도메인' },
];

export const ViewSelector: React.FC<ViewSelectorProps> = ({ selectedView, onViewChange }) => {
  const items: FloatButtonItem[] = useMemo(() => {
    return viewConfig.map((config) => ({
      key: config.type,
      icon: config.icon,
      description: config.label,
      onClick: () => onViewChange(config.type),
      type: selectedView === config.type ? 'primary' : 'default',
    }));
  }, [selectedView, onViewChange]);

  const selectedIcon = useMemo(() => {
    return viewConfig.find((config) => config.type === selectedView)?.icon || <CloudServerOutlined />;
  }, [selectedView]);

  return (
    <FloatButtonGroup
      icon={selectedIcon}
      description="계층"
      items={items}
      shape="square"
      size="medium"
      type="primary"
      placement="right"
      trigger="click"
      autoCloseOnSelect={true}
      style={{ position: 'absolute', left: 24, bottom: 24 }}
    />
  );
};
